import React from 'react';
import { NavLink } from 'react-router-dom';

import { Form } from '../../../../components';

const Component = ({ id, form, state, handlers }) => (
  <div className="col-md-6 p-0">
    <div className="card">
      <div className="card-header border-bottom">
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="card-title">{id ? 'Edit user' : 'Add new user'}</h5>
          <div>
            <NavLink className="btn btn-round btn-warning" to={`/users`}>
              <i className="nc-icon nc-minimal-left"/>
            </NavLink>
          </div>
        </div>
      </div>
      <Form.Progress on={state.pending} />
      <Form.Messages form={form} state={state} onClose={handlers.onReset} />
      <div className="card-body">
        <form onSubmit={form.handleSubmit(handlers.onSubmit)} onChange={handlers.onReset}>
          <label>Username</label>
          <div className="form-group">
            <input name="username" ref={form.register} maxLength={25} className="form-control" placeholder="Enter username"/>
          </div>
          <label>Password</label>
          <div className="form-group">
            <input name="password" type="password" ref={form.register} maxLength={25} className="form-control" placeholder="Enter password" autoComplete="new-password"/>
          </div>
          <label>E-mail</label>
          <div className="form-group">
            <input name="email" ref={form.register} maxLength={100} className="form-control" placeholder="Enter e-mail"/>
          </div>
        </form>
      </div>
      <div className="card-footer border-top">
        <Form.Submit form={form} state={state} label="Save" onSubmit={form.handleSubmit(handlers.onSubmit)} />
      </div>
    </div>
  </div>
);

export default Component;
